import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router';

import type { Billable } from '@feathr/blackbox';
import Page from '@feathr/extender/App/Page';
import { useStore } from '@feathr/extender/state';

import BillableForm, { getLabel } from '../BillableForm';

function BillableAddPage(): JSX.Element {
  const { t } = useTranslation();
  const { Billables } = useStore();

  // Get default param from page url
  const defaultParam = new URLSearchParams(window.location.search).get('default');
  const isDefault: true | undefined = defaultParam === 'true' || defaultParam === '1' || undefined;

  const billableRef = useRef<Billable | null>(null);
  // Expensive to create, so create it once
  if (billableRef.current === null) {
    billableRef.current = Billables.create();
  }

  useEffect(() => {
    if (billableRef.current) {
      billableRef.current.discardDirty();
    }
  }, [billableRef.current]);

  return (
    <Page title={getLabel(true, !!isDefault)}>
      <>
        <Prompt
          message={t('You have unsaved changes. Are you sure you want to leave this page?')}
          when={billableRef.current.isDirty}
        />
        <BillableForm billable={billableRef.current} isDefault={isDefault} />
      </>
    </Page>
  );
}

export default observer(BillableAddPage);
